const API = process.env.REACT_APP_BACKEND_URL;

// Fire-and-forget click counter; never blocks or breaks navigation.
export const track = (target, lang) => {
  if (!API) return;
  try {
    const body = JSON.stringify({ target, lang });
    const url = `${API}/api/clicks`;
    if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }))) return;
    fetch(url, { method: "POST", body, keepalive: true, headers: { "Content-Type": "text/plain" } }).catch(() => {});
  } catch (e) {}
};
